import { InjectionToken, TransferState, inject, makeStateKey, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { HttpLink } from "apollo-angular/http";
import { ApolloClientOptions, ApolloLink, DocumentNode, InMemoryCache, NormalizedCacheObject } from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { Constants } from "./config/app.constants";
import { PreviewModeService } from "./core/services/preview-mode.service";
import { print } from "graphql";

const STATE_KEY = makeStateKey<NormalizedCacheObject>('apollo.state');

export const MY_APOLLO_CACHE = new InjectionToken<InMemoryCache>('apollo-cache');

export const createApollo = (): ApolloClientOptions<NormalizedCacheObject> => {
  const httpLink = inject(HttpLink);
  const constant = inject(Constants);
  const transferState = inject(TransferState);
  const cache = inject(MY_APOLLO_CACHE);
  const preview = inject(PreviewModeService);
  const platformId = inject(PLATFORM_ID);

  // Set authentication header
  const auth = setContext((operation, context) => {
    return {
      headers: {
        Authorization: `Bearer ${preview.isPreviewMode() ? constant.ContentFulPreviewToken : constant.ContentFulAccessToken}`,
      },
    };
  });

  const isBrowser = isPlatformBrowser(platformId);

  if (isBrowser) {
    // On browser, restore cache from SSR if available
    const state = transferState.get<NormalizedCacheObject>(STATE_KEY, null);
    if (state) {
      cache.restore(state);
    }
  } else {
    // On server, serialize cache state for transfer to client
    transferState.onSerialize(STATE_KEY, () => {
      return cache.extract();
    });
    // Reset cache after extraction to avoid sharing between requests
    cache.reset();
  }

  const operationPrinter = (operation: DocumentNode) => {
    const printed = print(operation);
    const minified = printed.replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g, " ");
    return minified;
  }

  return {
    link: (ApolloLink.from([auth, httpLink.create({ uri: constant.APIBasePathContentFul, operationPrinter })])),
    cache,
    ssrMode: isBrowser ? false : true,
    ssrForceFetchDelay: isBrowser ? 100 : 0
  };
}




